var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4229 14.1225C18.0774 15.9444 15.2105 19.0001 11.1245 19.0001C6.93009 19.0001 4.11639 15.9827 2.81248 14.1832C1.88963 12.9101 1.89144 11.1443 2.817 9.88892C4.16335 8.06332 7.03303 5.00012 11.1245 5.00012C15.2818 5.00012 18.11 8.02319 19.4265 9.82546C20.3548 11.0967 20.353 12.8635 19.4229 14.1225ZM17.9853 10.9501C16.872 9.42506 14.4998 6.86679 11.1245 6.86679C7.81141 6.86679 5.39773 9.46986 4.25364 11.0211C3.80847 11.6249 3.81028 12.4463 4.25816 13.0641C5.3598 14.5836 7.71659 17.1335 11.1245 17.1335C14.433 17.1335 16.844 14.5379 17.9871 12.9904C18.435 12.3847 18.4341 11.5652 17.9853 10.9501ZM14.7364 12.0001C14.7364 14.0591 13.1164 15.7335 11.1245 15.7335C9.13247 15.7335 7.51252 14.0591 7.51252 12.0001C7.51252 9.94119 9.13247 8.26679 11.1245 8.26679C13.1164 8.26679 14.7364 9.94119 14.7364 12.0001ZM12.9304 12.0001C12.9304 10.9707 12.1205 10.1335 11.1245 10.1335C10.1285 10.1335 9.31849 10.9707 9.31849 12.0001C9.31849 13.0296 10.1285 13.8668 11.1245 13.8668C12.1205 13.8668 12.9304 13.0296 12.9304 12.0001Z",
    fill: "#26445A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1624 6.61499L13.6411 3.38335",
    stroke: "#26445A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08521 6.61499L8.60645 3.38335",
    stroke: "#26445A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5439 10.4448C16.19 7.37277 9.92624 3.0719 3.70234 10.4448",
    stroke: "#26445A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5439 5.05846L16.2698 8.17041",
    stroke: "#26445A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44873 5.30895L5.72285 8.4209",
    stroke: "#26445A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/Visibility.ec7a7820bdf1bafce222b64a8ee6aac0.svg";
export { ForwardRef as ReactComponent };